import i18n from "i18next";
import { initReactI18next } from "react-i18next";

i18n.use(initReactI18next).init({
  resources: {
    kz: {
      translation: {
        header_about_us: "Біз туралы",
        header_mission: "Біздің миссия",
        header_kenes: "Қамқоршылық кеңес",
        header_documents: "Заңды құжаттар",
        header_alumni: "Түлектер",
        header_reports: "Есептер",
        header_vacancy: "Вакансия",
        header_news: "Жаңалықтар",
        header_projects: "Жобалар",
        main_title_1: "Есік БИЛ түлектерінің",
        main_title_2: "атты қоғамдық бірлестігі",
        counter_1: "лицей түлектерінің саны",
        counter_2: "бірлестік ашылғалы жиналған қаржылай көмек",
        counter_3: "қолдау білдірген түлек саны",
        subscription_header: "Тарифтік жоспар",
        subscription_description:
          "Қорымыздың жобаларын қолдау үшін ай сайынғы жазылымға қосылыңыз",
        subscription_empty: "Тарифтік жоспар жоқ",
        subscription_link_1: "Осы ",
        subscription_link_2: "сілтеме",
        subscription_link_3: " арқылы жазылымнан бас тарта аласыз",
        subscription_month: "₸ / айына",
        subscription_button: "Жазылу",
        subscription_name: "Подписканың аты:",
        projects_title: "Жобалар",
        projects_all: "Барлық жобалар →",
        projects_empty: "Жобалар жоқ",
        projects_button: "Үлес қосу",
        projects_goal: "Мақсат:",
        projects_money: "ЖИНАЛДЫ",
        shop_title: "Мерч",
        shop_empty: "Мерч жоқ",
        shop_price: "Бағасы:",
        shop_order: "Тапсырыс беру",
        shop_order_name: "Аты:",
        shop_order_name_placeholder: "Атыңызды енгізіңіз",
        shop_order_phone: "Телефон нөмірі:",
        shop_order_phone_placeholder: "Телефон нөміріңізді енгізіңіз",
        shop_order_phone_error: "Нөмір сандардан тұруы керек",
        shop_order_item_name: "Тапсырыс атауы",
        shop_order_back: "Бас тарту",
        news_title: "Жаңалықтар",
        news_all: "Барлық жаңалықтар →",
        news_empty: "Жаңалықтар жоқ",
        calendar_title: "Іс-шаралар күнтізбесі",
        calendar_all: "Жылдық күнтізбесі →",
        calendar_empty: "Іс-шаралар жоқ",
        sponsors_title: "Демеушілер / Серіктестер",
        footer_nav: "Навигация",
        footer_nav_home: "Басты бет",
        footer_nav_about: "Біз тұралы",
        footer_nav_merch: "Мерч",
        footer_nav_alumni: "Түлектер",
        footer_doc: "Құжаттар",
        footer_doc_offer: "Қоғамдық оферта",
        footer_doc_privacy: "Құпиялық саясаты",
        footer_doc_payment: "Онлайн төлем қауіпсіздігі",
        footer_text:
          "© 2015 Есік БИЛ түлектерінің “АҒАЛҚА” атты қоғамдық бірлестігі",
      },
    },
    ru: {
      translation: {
        header_about_us: "О нас",
        header_mission: "Наша миссия",
        header_kenes: "Попечительский совет",
        header_documents: "Законодательные документы",
        header_alumni: "Выпускники",
        header_reports: "Отчеты",
        header_vacancy: "Вакансия",
        header_news: "Новости",
        header_projects: "Проекты",
        main_title_1: "Общественное объединение",
        main_title_2: "ассоциация выпускников Есик БИЛ",
        counter_1: "Количество выпускников лицея",
        counter_2:
          "Собранная финансовая помощь с момента открытия Общественное объединение",
        counter_3: "Количество выпускников, оказавших поддержку",
        subscription_header: "Тарифный план",
        subscription_description:
          "Подпишитесь на ежемесячную подписку, чтобы поддержать проекты нашего фонда",
        subscription_empty: "Тарифные планы отсутствуют",
        subscription_link_1: "Вы можете отменить подписку, используя эту ",
        subscription_link_2: "ссылку",
        subscription_link_3: "",
        subscription_month: "₸ / в месяц",
        subscription_button: "Подписаться",
        subscription_name: "Название подписки:",
        projects_title: "Проекты",
        projects_all: "Все проекты →",
        projects_empty: "Проектов нет",
        projects_button: "Поддержать",
        projects_goal: "Цель:",
        projects_money: "СОБРАНО",
        shop_title: "Мерч",
        shop_empty: "Мерч отсутствует",
        shop_price: "Цена:",
        shop_order: "Заказать",
        shop_order_name: "Имя:",
        shop_order_name_placeholder: "Введите ваше имя",
        shop_order_phone: "Номер телефона:",
        shop_order_phone_placeholder: "Введите ваш номер телефона",
        shop_order_phone_error: "Номер должен состоять из цифр",
        shop_order_item_name: "Название заказа",
        shop_order_back: "Назад",
        news_title: "Новости",
        news_all: "Все новости →",
        news_empty: "Новостей нет",
        calendar_title: "Календарь мероприятий",
        calendar_all: "Годовой календарь →",
        calendar_empty: "Мероприятий нет",
        sponsors_title: "Спонсоры",
        footer_nav: "Навигация",
        footer_nav_home: "Главная",
        footer_nav_about: "О нас",
        footer_nav_merch: "Мерч",
        footer_nav_alumni: "Выпускники",
        footer_doc: "Документы",
        footer_doc_offer: "Публичная оферта",
        footer_doc_privacy: "Политика конфиденциальности",
        footer_doc_payment: "Безопасные онлайн платежи",
        footer_text:
          "© 2015 Общественное объединение “АҒАЛҚА” ассоциация выпускников Есик БИЛ",
      },
    },
  },
  lng: "kz",
  fallbackLng: "kz",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
